module.exports = __webpack_public_path__ + "img/lock-solid.3cd9658a.svg";